<!--
 * @Author       : Archer<ahh666@qq.com>
 * @Date         : 2023-10-08 11:09:29
 * @LastEditors  : Archer<ahh666@qq.com>
 * @LastEditTime : 2023-10-15 14:22:26
 * @FilePath     : \youxi\youxi\src\views\XXHavingYou\index.vue
 * @Description  : Description
-->
<template>
  <div class="xx-having-you">
    <div class="xxhy-head">
      <img class="xxhy-kv1" src="./img/bg_part1.png" />
      <img class="xxhy-button1" @click="openTreasure" src="./img/button1.png" />
    </div>
    <Scrolling v-if="lotteryRecord.length" :lotteryRecord="lotteryRecord"/>
    <div class="xxhy-main">
      <img class="xxhy-main-title" src="./img/rank-title.png" />
      <div class="xxhy-main-rank">
        <RankList
          style="margin-right: 30px;"
          :type="1"
          :list="rankRecoList"
          :userInfo="myRankInfo.user"
          :myRank="myRankInfo.my_invite"
        />
        <RankList
          :type="2"
          :list="rankTradeList"
          :userInfo="myRankInfo.user"
          :myRank="myRankInfo.my_order"
        />
      </div>
    </div>
    <div class="xxhy-footer">
      <img class="xxhy-footer-title" src="./img/footer-title.png" />
      <div class="xxhy-footer-main">
        <div class="xxhy-footer-main--title xxhy-footer-main--title1">
          <div class="xxhy-footer-main--title_line1">蟹蟹有你 蟹力十足</div>
          <div class="xxhy-footer-main--title_line2">
            游严选游戏节邀您共享游严选盛宴
          </div>
        </div>
        <div class="xxhy-footer-main--part1">
          <div
            class="footer-part1-item"
            v-for="(v, k) in footerVideoList"
            :key="k"
          >
            <img
              @click="handleJump(v.url)"
              class="footer-part1-item--video"
              :src="v.image"
            />
            <img
              src="./img/play-btn.png"
              @click.stop.prevent="handleJump(v.url)"
              class="footer-video-play"
            />
            <div class="footer-part1-item--desc">
              <div class="footer-video-title">{{ v.title }}</div>
              <div class="footer-video-playsum">
                <img src="./img/footer-video-icon.png" />{{ v.click }}万
              </div>
            </div>
          </div>
        </div>

        <div class="xxhy-footer-main--title xxhy-footer-main--title2">
          <div class="xxhy-footer-main--title_line1">游严选游戏官方</div>
          <div class="xxhy-footer-main--title_line2">关注收藏不迷路</div>
        </div>
        <div class="xxhy-footer-main--part2">
          <div
            class="footer-part2-item"
            v-for="(v, k) in footerPart2Cont"
            :key="k"
            @click="handleBottomClick(v, k)"
          >
            <img class="footer-part2-item--icon" :src="v.img" />
            <div class="footer-part2-item--text">{{ v.label }}</div>
            <div class="footer-part2-item--qrcode" v-if="k === 1">
              <img src="./img/wx-qrcode.png" />
              <div class="qrcode-desc">扫码关注游严选公众号</div>
            </div>
          </div>
        </div>
        <img class="xxhy-footer-main--pxlogo" src="./img/footer-px-logo.png" />
      </div>
    </div>
    <div class="xxhy-page-footer">
      <img src="./img/page-footer-bg.png" />
      <div class="xxhy-page-footer--text">
        &copy;版权所有 游严选游戏服务网 All Rights Reserved 抄袭必究
      </div>
    </div>
    <!-- 侧边按钮 -->
    <div class="xxhy-side-btn">
      <img src="./img/side-wdjp.png" @click="openMyReward" />
      <img src="./img/side-rwlb.png" @click="openTaskList" />
      <img src="./img/side-hdgz.png" @click="goActiveRule" />
    </div>
    <!-- 打开宝箱dialog -->
    <Dialog v-if="showTreasureDialog" @close="showTreasureDialog = false">
      <div class="xxhy-dialog1-main">
        <div class="glod-box">
          <img class="treasure" src="./img/dialog1-box-glod.png" />
          <img
            class="btn"
            @click="lottery('gold')"
            src="./img/dialog1-btn-glod.png"
          />
          <div class="had-key">
            已有黄金钥匙：<img class="key-icon" src="./img/dialog1-key1.png" />
            X
            {{ lotteryNum.gold }}
          </div>
          <div class="reward-detail" @click="checkPrize(1)">查看奖品明细</div>
        </div>
        <div class="diamond-box">
          <img class="treasure" src="./img/dialog1-box-diamond.png" />
          <img
            class="btn"
            @click="lottery('diamond')"
            src="./img/dialog1-btn-diamond.png"
          />
          <div class="had-key">
            已有钻石钥匙：<img class="key-icon" src="./img/dialog1-key2.png" />
            X
            {{ lotteryNum.diamond }}
          </div>
          <div class="reward-detail" @click="checkPrize(2)">查看奖品明细</div>
        </div>
      </div>
    </Dialog>
    <!-- 活动规则dialog -->
    <Dialog v-if="showHDGZDialog" @close="showHDGZDialog = false">
      <div class="xxhy-dialog2-main">
        <img class="xxhy-dialog2-title" src="./img/dialog-title-hdgz.png" />
        <div class="rule-title">活动时间</div>
        <div class="rule-date">2023年10月1日-2023年10月15日</div>
        <div class="rule-title">参加要求</div>
        <ul class="rule-list">
          <li>
            支付号价10%，账号发生找回后十五日内无法追回，平台按照购买的包赔合同类型进行至少100%的全额赔付。
          </li>
          <li>
            特别提醒:
            平台在处理周期(十五日)内追回账号，号主需无条件接受账号(再发生找回事件平台还会继续进行售后流程)，如在处理周期(十五日)内追回游戏账号，号主拒收账号将视为默认放弃包赔服务，如号主需要维权平台将辅助维权，并非主导。
          </li>
          <li>
            条件:
            只要账号购买后没转手，都无条件补偿，若买家谎称账号被找回或隐瞒账号已转手，按诈骗处理
          </li>
        </ul>
      </div>
    </Dialog>
    <!-- 奖品明细dialog -->
    <Dialog v-if="showPrizeDialog" @close="showPrizeDialog = false">
      <div class="xxhy-dialog2-main">
        <img class="xxhy-dialog2-title" src="./img/dialog-title-jpmx.png" />
        <div class="reward-head">
          <span>奖品名称</span>
          <span>价值</span>
        </div>
        <div class="reward-body">
          <div class="reward-body-item" v-for="v in rewardList" :key="v.id">
            <span class="text-ellipsis">{{ v.prize_name }}</span>
            <span>{{ v.prize_price }} 元</span>
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 任务列表dialog -->
    <Dialog :type="2" v-if="showTaskDialog" @close="showTaskDialog = false">
      <div class="xxhy-dialog3-main">
        <img class="xxhy-dialog3-title" src="./img/dialog3-title.png" />
        <div class="task-body">
          <div
            class="task-body-content"
            v-for="(v, k) in taskList"
            :key="v.label"
          >
            <img class="task-img" :src="v.img" />
            <div class="task-content">
              <span class="task-label">{{ v.label }}</span>
              <span class="task-desc">{{ v.desc }}</span>
            </div>
            <div class="task-btn" @click="taskBtnClick(k)">{{ v.btnText }}</div>
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 抽奖成功dialog -->
    <Dialog
      :type="3"
      v-if="showlotteryDialog"
      @close="showlotteryDialog = false"
    >
      <div class="xxhy-dialog4-main">
        <img class="reward-bg" src="./img/reward-bg.png" />
        <img class="reward-img" :src="prizeInfo.prize_img" />
        <div class="reward-value">
          <span v-if="prizeInfo.prize_type === 2"> 价值</span> ￥<span
            class="reward-prize"
            >{{ prizeInfo.prize_price }}</span
          >
        </div>
        <div class="reward-name">{{ prizeInfo.prize_name }} X1</div>
        <img
          class="reward-btn"
          @click="handlePrize(prizeInfo.prize_type)"
          :src="require(`./img/reward-btn${prizeInfo.prize_type}.png`)"
        />
        <div class="reward-tip">
          奖品已放入您的账户，请登陆游严选账号APP 或者官网（pxb7.com）使用
        </div>
        <!-- 动画元素 -->
        <!-- <div class="lottery-content">
          <div class="lottery-circle">
            <image class="lottery-circle1" src="@/static/my/coupon/win-circle.png"></image>
          </div>
          <div class="fashe-all">
            <image class="lottery-fashe" src="@/static/my/coupon/win-fashe.png"></image>
            <image class="lottery-fashe1" src="@/static/my/coupon/win-fashe.png"></image>
            <image class="lottery-fashe2" src="@/static/my/coupon/win-fashe.png"></image>
            <image class="lottery-fashe3" src="@/static/my/coupon/win-fashe.png"></image>
            <image class="lottery-fashe4" src="@/static/my/coupon/win-fashe.png"></image>
            <image class="lottery-fashe5" src="@/static/my/coupon/win-fashe.png"></image>
          </div>
        </div> -->
      </div>
    </Dialog>
    <!-- qq社群dialog -->
    <Dialog
      :type="1"
      v-if="showqqGroupDialog"
      @close="showqqGroupDialog = false"
    >
      <div class="xxhy-dialog2-main">
        <img class="xxhy-dialog2-title" src="./img/qq-group-title.png" />
        <div class="qq-group-body">
          <div
            class="qq-group-body-content"
            v-for="v in qqGroupList"
            :key="v.qq"
          >
            <div class="group-content">
              <span class="group-name text-ellipsis" :title="v.name">{{
                v.name
              }}</span>
              <span class="group-qq"> QQ群：{{ v.qq }}</span>
            </div>
            <div class="group-btn" @click="handleJump(v.link)">加入</div>
          </div>
        </div>
      </div>
    </Dialog>
    <!-- 收货地址dialog -->
    <Dialog
      :type="1"
      v-if="showShipAddrDialog"
      @close="showShipAddrDialog = false"
    >
      <div class="xxhy-dialog2-main">
        <img class="xxhy-dialog2-title" src="./img/ship-addr-title.png" />
        <div class="ship-addr-body">
          <div class="form-item">
            <span>收货人</span>
            <el-input
              v-model="shipAddrForm.name"
              placeholder="请填写收货人的姓名"
            ></el-input>
          </div>
          <div class="form-item">
            <span>手机号码</span>
            <el-input
              v-model="shipAddrForm.telephone"
              placeholder="请填写收货人的手机号"
            ></el-input>
          </div>
          <div class="form-item">
            <span>省市区</span>
            <el-cascader
              placeholder="请选择省市区"
              v-model="shipAddrForm.area"
              :options="ChinaAddressArea"
              :props="{
                label: 'name'
              }"
              @change="handleAddressChange"
            ></el-cascader>
          </div>
          <div class="form-item">
            <span>详细地址</span>
            <el-input
              v-model="shipAddrForm.address"
              placeholder="请输入地址"
              maxlength="30"
              show-word-limit
            ></el-input>
          </div>
          <div class="btn-group">
            <div class="btn-cancel" @click="showShipAddrDialog = false">
              取消
            </div>
            <div
              class="btn-save"
              :class="{ 'btn-save-disabled': !canClickSaveShipAddr }"
              @click="saveShipAddr"
            >
              保存并领取
            </div>
          </div>
          <div class="ship-addr-tip">
            <img src="./img/tip-icon.png" />
            因涉及到实物寄送，请确保填写的信息正确，如有问题请联系客服
          </div>
        </div>
      </div>
    </Dialog>
    <LoginDialog v-if="showLoginDialog" @close="showLoginDialog = false" />
    <input type="text" id="contactUsDialog-body-input" />
  </div>
</template>

<script>
import {
  getRankApi,
  getMyRankApi,
  getRadioUrlApi,
  getActivityInfoApi,
  getLotteryNumApi,
  lotteryApi,
  getActiveStatusApi,
  underPrizeReceiveApi
} from "./api";
import { addressArea } from "../Contract/newMap";
import Dialog from "./Dialog.vue";
import RankList from "./RankList.vue";
import LoginDialog from "./LoginDialog.vue";
import Scrolling from './Scrolling.vue';

const footerPart2Cont = [
  {
    label: "官方微博",
    url: "https://weibo.com/5051227271?refer_flag=1001030103_",
    img: require("./img/footer-wb.png")
  },
  {
    label: "官方公众号",
    url: "",
    img: require("./img/footer-wx.png")
  },
  {
    label: "官方B站",
    url: "https://space.bilibili.com/35798565",
    img: require("./img/footer-bili.png")
  },
  {
    label: "官方贴吧",
    url:
      "https://tieba.baidu.com/f?ie=utf-8&kw=%E8%9E%83%E8%9F%B9%E8%B4%A6%E5%8F%B7&fr=search",
    img: require("./img/footer-tieba.png")
  },
  {
    label: "官方社群",
    url: "",
    img: require("./img/footer-shequ.png")
  }
];

const taskList = [
  {
    img: require("./img/task1.png"),
    label: "邀请好友注册",
    desc: "可获得3把黄金钥匙",
    btnText: "复制链接"
  },
  {
    img: require("./img/task2.png"),
    label: "成功卖出账号",
    desc: "可获得5把黄金钥匙",
    btnText: "去卖号"
  },
  {
    img: require("./img/task3.png"),
    label: "成功买到账号",
    desc: "可获得5把钻石钥匙",
    btnText: "去买号"
  },
  {
    img: require("./img/task4.png"),
    label: "每日进入活动页参与活动",
    desc: "可获得3把黄金钥匙",
    btnText: "已完成"
  }
];
export default {
  components: { RankList, Dialog, LoginDialog, Scrolling },
  data() {
    return {
      canClickLottery: true,
      showLoginDialog: false,
      showShipAddrDialog: false,
      showqqGroupDialog: false,
      showlotteryDialog: false,
      showTreasureDialog: false,
      showHDGZDialog: false,
      showPrizeDialog: false,
      showTaskDialog: false,
      lotteryRecord: [], // 中奖信息，弹幕池
      glodPrize: [], // 黄金奖池
      diamondPrize: [], // 钻石奖池
      qqGroupList: [], // qq社群
      rankRecoList: [],
      rankTradeList: [],
      myRankInfo: {}, // 我的排名信息
      prizeInfo: {}, // 中奖信息
      lotteryNum: {}, // 抽奖次数
      footerVideoList: {},
      footerPart2Cont,
      taskList,
      urlParams: {},
      ChinaAddressArea: [],
      shipAddrForm: {
        name: "",
        telephone: "",
        area: [],
        address: ""
      }
    };
  },
  computed: {
    canClickSaveShipAddr() {
      return Object.values(this.shipAddrForm).every(
        item => item && item.length > 0
      );
    }
  },
  async created() {
    this.urlParams = this.$route.query;
    this.getActivityInfo();
    this.getRankList();
    this.getMyRankInfo();
    this.getVideoList();
    await this.getActiveStatus();
  },
  mounted() {
    this.ChinaAddressArea = addressArea;
  },
  methods: {
    async getActiveStatus() {
      return getActiveStatusApi({
        activity_id: this.urlParams.a_id
      })
        .then(res => {
          const { status, text } = res.data;
          if (!status) {
            this.$message({
              type: "error",
              center: true,
              message: text
            });
          }
          return status;
        })
        .catch(err => {
          this.$message({
            type: "success",
            center: true,
            message: err.msg
          });
        });
    },
    saveShipAddr() {
      if (!this.canClickSaveShipAddr) {
        return;
      }
      underPrizeReceiveApi({
        activity_id: this.urlParams.a_id,
        lottery_id: this.prizeInfo?.prize_id,
        name: this.shipAddrForm.name,
        telephone: this.shipAddrForm.name,
        address: this.shipAddrForm.area.join("") + this.shipAddrForm.address
      }).then(res => {
        this.$message({
          type: "success",
          center: true,
          message:
            "奖品领取成功，7-10个工作日会寄出，若有问题请咨询活动页面客服"
        });
        this.showShipAddrDialog = false;
      });
    },
    handleAddressChange(v) {},
    handlePrize(type) {
      this.showlotteryDialog = false;
      if (type === 1) {
        window.open("/allGame");
        return;
      }
      // 实物领取 展示收货地址
      this.showShipAddrDialog = true;
    },
    loginValidor() {
      const isLogin = JSON.parse(
        localStorage.getItem("loginStatus") || "false"
      );
      if (!isLogin) {
        this.showLoginDialog = true;
      }
      return isLogin;
    },
    taskBtnClick(k) {
      const uid = JSON.parse(localStorage.getItem("userData") || "{}").user_id;
      if (k === 0) {
        // 复制的链接拼接逻辑 + u_id + a_id + source
        this.copy(location.href + `&u_id=${uid}&sce=3`);
      }
      if (k === 1) {
        window.open("/accountSell");
      }
      if (k === 2) {
        window.open("/allGame");
      }
    },
    copy(v) {
      var input = document.getElementById("contactUsDialog-body-input");
      input.value = v; // 修改文本框的内容
      input.select(); // 选中文本
      document.execCommand("copy"); // 执行浏览器复制命令
      this.$message({
        type: "success",
        center: true,
        message: "复制成功"
      });
    },
    getRankList() {
      getRankApi({ activity_id: this.urlParams.a_id }).then(res => {
        this.rankRecoList = res.data.invite || [];
        this.rankTradeList = res.data.order || [];
      });
    },
    getMyRankInfo() {
      getMyRankApi({ activity_id: this.urlParams.a_id }).then(res => {
        this.myRankInfo = res.data || {};
      });
    },
    getVideoList() {
      getRadioUrlApi().then(res => {
        this.footerVideoList = res.data;
      });
    },
    getLotteryNum() {
      getLotteryNumApi({ activity_id: this.urlParams.a_id }).then(res => {
        this.lotteryNum = res.data || {};
        const { diamond, gold } = res.data;
        if (diamond + gold > 0) {
          this.showTreasureDialog = true;
        } else {
          this.showTreasureDialog = false;
          this.showTaskDialog = true;
        }
      });
    },
    // 底部超链接点击
    handleBottomClick(v, k) {
      if (k === 4) {
        this.showqqGroupDialog = true;
      }
      if (v.url) {
        this.handleJump(v.url);
      }
    },
    handleJump(url) {
      window.open(url);
    },
    // 打开宝箱
    async openTreasure() {
      const activeOverStatus = await this.getActiveStatus();
      if (!activeOverStatus) {
        return;
      }
      if (this.loginValidor()) {
        this.getLotteryNum();
      }
    },
    // 打开任务列表
    openTaskList() {
      if (this.loginValidor()) {
        this.showTaskDialog = true;
      }
    },
    // 活动规则
    goActiveRule() {
      window.open(
        `${process.env.VUE_APP_WEBSITE}/tradeTip?id=183&parent_id=0`,
        "_blank"
      );
    },
    // 打开我的背包
    openMyReward() {
      if (this.loginValidor()) {
        window.open("/personalCenter/Reward");
      }
    },
    checkPrize(type) {
      this.rewardList = {
        ...(type === 1 ? this.glodPrize : this.diamondPrize)
      };
      this.showPrizeDialog = true;
    },
    getActivityInfo(type) {
      getActivityInfoApi({ activity_id: this.urlParams.a_id }).then(res => {
        this.glodPrize = res.data.gold_prize || [];
        this.diamondPrize = res.data.diamond_prize || [];
        this.qqGroupList = res.data.qq_group || [];
        this.lotteryRecord = res.data.lottery_record || [];
      });
    },
    async lottery(type) {
      if(!this.canClickLottery) {
        return
      }
      this.canClickLottery = false
      const activeOverStatus = await this.getActiveStatus();
      if (!activeOverStatus) {
        return;
      }
      if (this.lotteryNum[type] === 0) {
        this.showTreasureDialog = false;
        this.showTaskDialog = true;
        return;
      }
      lotteryApi({
        activity_id: this.urlParams.a_id,
        lottery_type: type
      }).then(res => {
        const { status, msg, prize_info } = res.data;
        if (status !== 1) {
          this.$message({
            type: "error",
            center: true,
            message: msg
          });
          return;
        }
        if (status === 0) {
          this.lotteryNum[type]--;
          this.$message({
            type: "error",
            center: true,
            message: "未中奖"
          });
          return;
        }
        this.prizeInfo = prize_info || {
          prize_type: 1,
          prize_price: 49,
          prize_name: "双击打开"
        };
        this.lotteryNum[type]--;
        this.showlotteryDialog = true;
        this.canClickLottery = true
      });
    }
  }
};
</script>

<style lang="less">
@keyframes xxhy-kv-btn {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.1);
  }
}

.text-ellipsis {
  overflow: hidden;

  white-space: nowrap;
  text-overflow: ellipsis;
}
.xx-having-you {
  margin-bottom: -25px;
  // .lottery-content{
  //   position: relative;
  //   top: -10vh;
  //   left: calc(50vw - 50px);
  //   .lottery-circle{
  //     position: absolute;
  //   }
  //   .fashe-all{
  //     position: absolute;
  //     left: 50px;
  //     top: 60px;
  //   }
  //   /**
  //    * index 必备，保证识别动画唯一性，禁止相同值
  //    * x - x轴偏移量，三个选项 0 100vw -100vw
  //    * y - y轴偏移量，三个选项 0 100vh -100vh
  //    * roate - 标识旋转角度
  //    * defaultScale - 放大倍率，默认为3
  //    * 使用demo：@include lotteryMixin(1,100vw,100vh,0deg,3);
  //    */
  //   .mixin-lotteryMixin(@index,@x,@y,@rotate,@defaultScale:3){
  //     animation: newtransform-#{@index} 0.84s;
  //     animation-fill-mode: forwards;
  //     transform: rotate(@rotate);
  //     @keyframes newtransform-#{@index} {
  //       0%{
  //         transform: translate3d(0,0,0) scale(1) rotate(@rotate);
  //       }
  //       100%{
  //         transform: translate3d(@x,@y,0) scale(@defaultScale) rotate(@rotate);
  //       }
  //     }
  //   }
  //   @width: 10px;
  //   @height: 5px;
  //   // 上
  //   .lottery-fashe{
  //     position: absolute;
  //     width: 29px;
  //     height: 85px;
  //     top: -15px;
  //     left: -4px;
  //     @include lotteryMixin(1,0,-100vh,0deg);
  //   }
  //   // 上左
  //   .lottery-fashe1{
  //     position: absolute;
  //     width: 18px;
  //     height: 51px;
  //     top: 0;
  //     left: -7px;
  //     @include lotteryMixin(2,-100vw,-100vh,-30deg);
  //   }
  //   // 下左
  //   .lottery-fashe2{
  //     position: absolute;
  //     width: 36px;
  //     height: 103px;
  //     top: -48px;
  //     left: -26x;
  //     @include lotteryMixin(3,-100vw,100vh,-140deg);
  //   }
  //   // 下
  //   .lottery-fashe3{
  //     position: absolute;
  //     width: 14px;
  //     height: 39px;
  //     top: 11px;
  //     left: 0;
  //     @include lotteryMixin(4,0,100vh,-175deg);
  //   }
  //   // 下右
  //   .lottery-fashe4{
  //     position: absolute;
  //     width: 18px;
  //     height: 51px;
  //     top: -15px;
  //     left: 25px;
  //     @include lotteryMixin(5,100vw,100vh,155deg);
  //   }
  //   // 上右
  //   .lottery-fashe5{
  //     position: absolute;
  //     width: 11px;
  //     height: 31px;
  //     top: -19px;
  //     left: 14px;
  //     @include lotteryMixin(6,50vh,-50vh,50deg);
  //   }
  //   .lottery-circle1{
  //     position: absolute;
  //     width: 100px;
  //     height: 100px;
  //     animation:zoomIn 0.44s ease-in forwards;
  //     @keyframes zoomIn {
  //       0% {
  //         transform: scale(1);
  //       }
  //       30% {
  //         transform: scale(4);
  //       }
  //       75%{
  //         transform: scale(9);
  //       }
  //       100%{
  //         transform: scale(15);
  //       }
  //     }
  //   }
  //   .lottery-mohu{
  //     position: absolute;
  //     width: 120px;
  //     height: 120px;
  //   }
  // }

  #contactUsDialog-body-input {
    position: fixed;
    bottom: 1;
    z-index: -1;
  }

  background: linear-gradient(180deg, #F7F5F2 0%, #F7F5F2 100%);

  * {
    box-sizing: border-box;
  }

  .xxhy {
    &-head {
      position: relative;
      // height: 826px;
    }

    &-kv1 {
      width: 100vw;
    }

    &-button1 {
      cursor: pointer;
      position: absolute;
      bottom: 120px;
      left: calc(50% - 169px);

      width: 338px;
      animation-name: xxhy-kv-btn;
      animation-direction: alternate;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      animation-duration: 0.6s;
    }

    &-main {
      display: flex;

      padding-top: 40px;
      width: 100%;

      align-items: center;
      flex-direction: column;

      &-title {
        display: flex;

        margin: 50px auto;
        width: 1026px;

        justify-content: center;
      }

      &-rank {
        display: flex;

        width: 100%;
        height: 1600px;

        background: url(./img/rank-footer-bg.png) no-repeat;
        background-position: bottom;
        background-size: 100% auto;

        justify-content: center;
      }
    }

    &-footer {
      display: flex;

      margin-top: -200px;

      align-items: center;
      flex-direction: column;

      &-title {
        margin: 40px 0;
      }

      &-main {
        position: relative;

        border: 1px solid #F7F5F2;
        border-radius: 4px;
        padding: 0 43px;
        width: 1258px;
        height: 825px;

        background: linear-gradient(
          180deg,
          #fff 0%,
          rgba(255, 255, 255, 0.52) 100%
        );

        &--title {
          &1 {
            background: url(./img/footer-part-title1.png);
          }
          &2 {
            background: url(./img/footer-part-title2.png);
          }
          position: relative;

          padding: 35px 0 0 14px;
          width: 342px;
          height: 112px;

          background-size: 100% 100%;

          &:nth-child(1) {
            margin-top: -26px;
          }

          &_line1 {
            font-size: 26px;
            font-weight: 600;

            color: #000;
          }

          &_line2 {
            font-size: 16px;

            color: #333;
          }
        }

        &--part1 {
          display: flex;

          margin-bottom: 45px;

          .footer-part1-item {
            position: relative;
            > img {
              cursor: pointer;
            }
            .footer-video-play {
              width: 75px;
              height: 75px;
              position: absolute;
              top: 128px;
              left: 229px;
            }
            &:nth-child(1) {
              margin-right: 69px;
            }

            &--video {
              border-radius: 4px;
              width: 533px;
              height: 316px;
            }

            &--desc {
              display: flex;

              width: 530px;
              height: 28px;

              align-items: center;
              justify-content: space-between;

              .footer-video-title {
                font-size: 24px;

                color: #333;

                flex: 1;
              }

              .footer-video-playsum {
                width: 100px;

                font-size: 20px;
                text-align: right;

                color: #979797;
                img {
                  width: 20px;
                  height: 20px;
                  position: relative;
                  top: 4px;
                  right: 6px;
                }
              }
            }
          }
        }

        &--part2 {
          display: flex;

          .footer-part2-item {
            display: flex;

            margin-right: 48px;

            flex-direction: column;
            position: relative;
            &:hover {
              .footer-part2-item--qrcode {
                display: block;
              }
            }
            &--qrcode {
              position: absolute;
              top: -256px;
              display: none;
              width: 240px;
              height: 245px;
              background: #fff;
              border-radius: 4px;
              padding-top: 20px;
              text-align: center;
              img {
                width: 170px;
                height: 170px;
              }
              .qrcode-desc {
                font-size: 20px;
                font-weight: bold;
                color: #ffa81d;
              }
            }

            &--icon {
              cursor: pointer;
              width: 114px;
              height: 111px;
            }

            &--text {
              margin-top: 8px;
              max-width: 110px;

              font-size: 20px;
              text-align: center;

              color: #838383;
            }
          }
        }

        &--pxlogo {
          position: absolute;
          right: -20px;
          bottom: -80px;

          width: 453px;
          height: 453px;
        }
      }
    }
  }
  .xxhy-side-btn {
    display: flex;
    flex-direction: column;
    height: 500px;
    justify-content: space-between;
    position: fixed;
    top: calc(50% - 250px);
    right: 35px;
    img {
      cursor: pointer;
      width: 147px;
      height: 147px;
    }
  }
  .xxhy-dialog1-main {
    display: flex;
    justify-content: space-between;
    width: 720px;
    margin-left: 180px;
    .glod-box,
    .diamond-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      height: 600px;
      padding-top: 127px;
      .key-icon {
        width: 32px;
        height: 32px;
      }
      .treasure {
        width: 295px;
        height: 225px;
      }
      .btn {
        margin-top: 20px;
        width: 240px;
        height: 91px;
        cursor: pointer;
      }
      .had-key {
        font-size: 22px;
        font-weight: 500;
        color: #ffffff;
        margin: 10px 0 20px 0;
        display: flex;
        align-items: center;
      }
      .reward-detail {
        cursor: pointer;
        font-size: 20px;
        color: #5A5F6B;
      }
    }
  }
  .xxhy-dialog2-main {
    display: block;
    width: 1050px;
    height: 644px;
    padding: 80px 50px;
    color: #dbdbdb;
    font-size: 24px;
    .rule-title {
      font-weight: 500;
      color: #ffffff;
      margin: 20px;
    }
    .rule-date {
      padding-left: 20px;
    }
    .rule-list {
      padding-left: 20px;
      margin: 0;
      li {
        margin-bottom: 10px;
        position: relative;
        &::after {
          position: absolute;
          left: -16px;
          top: 14px;
          content: " ";
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background: #f08c2b;
        }
      }
    }

    .reward-head {
      font-size: 24px;
      width: 950px;
      height: 68px;
      background: rgba(255, 255, 255, 0.1);
      line-height: 68px;
      color: #fff;
    }
    .reward-body {
      width: 950px;
      height: 370px;
      overflow: hidden scroll;
    }
    .reward-body-item {
      font-size: 24px;
      height: 89px;
      line-height: 89px;
      color: #dbdbdb;
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);
    }
    .reward-head,
    .reward-body-item {
      span {
        overflow: hidden;
        display: inline-block;
        text-align: center;
        &:nth-child(1) {
          width: 500px;
        }
        &:nth-child(2) {
          width: 400px;
        }
      }
    }
    .qq-group-body {
      width: 800px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      padding: 40px 0 0 100px;
      &-content {
        width: 324px;
        height: 60px;
        display: flex;
        justify-content: space-between;
        margin-bottom: 30px;

        align-items: center;
        .group-content {
          width: 230px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .group-name {
            color: #fff;

            font-size: 24px;
          }
          .group-qq {
            font-size: 18px;

            color: rgba(255, 255, 255, 0.4);
          }
        }
        .group-btn {
          font-size: 16px;
          width: 73px;
          height: 40px;
          line-height: 40px;
          text-align: center;
          color: #fff;
          background: var(--primary, #FF5A1F);
          border-radius: 3px;
        }
      }
    }
    .ship-addr-body {
      width: 900px;
      .form-item {
        color: #fff;

        font-size: 16px;
        display: flex;
        align-items: center;
        margin-top: 40px;
        .el-input:not(.el-input--suffix) {
          width: 800px;
        }
        .el-input__inner {
          border: 1px solid #666666;
          background: none;
          color: #999;
        }
        .el-input__count-inner {
          background: none;
        }

        > span {
          width: 100px;
          text-align: left;
        }
      }
      .btn-group {
        display: flex;
        justify-content: space-between;
        width: 310px;
        margin: 60px 0 0 320px;
        text-align: center;
        .btn-cancel {
          cursor: pointer;
          width: 140px;
          height: 40px;
          border-radius: 3px;
          border: 1.5px solid #fff;
          font-size: 16px;
          color: #fff;
          line-height: 40px;
        }
        .btn-save {
          cursor: pointer;
          width: 140px;
          height: 40px;
          line-height: 40px;
          background: var(--primary, #FF5A1F);
          border-radius: 3px;
          font-size: 16px;
          color: #ffffff;
          &-disabled {
            opacity: 0.4;
          }
        }
      }
      .ship-addr-tip {
        font-size: 12px;
        color: #999999;
        margin: 20px 0 0 300px;
        img {
          width: 12px;
          height: 12px;
          position: relative;
          top: 1px;
        }
      }
    }
  }
  .xxhy-dialog2-title {
    width: 840px;
    height: 30px;
    margin: 0 0 20px 50px;
  }
  .xxhy-dialog3-main {
    width: 100%;
    height: 100%;
    .task-body {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      height: 290px;
      .task-body-content {
        display: flex;
        width: 385px;
        justify-content: space-between;
        align-items: center;
        .task-img {
          width: 50px;
          height: 50px;
          margin-right: 10px;
        }
        .task-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          height: 46px;
          justify-content: space-between;
          .task-label {
            font-size: 16px;
            font-weight: 600;
            color: #ffffff;
          }
          .task-desc {
            font-size: 14px;
            color: #9d9d9d;
          }
        }
        .task-btn {
          cursor: pointer;
          width: 87px;
          height: 40px;
          line-height: 40px;
          background: var(--primary, #FF5A1F);
          border-radius: 3px;
          color: #fff;
          font-size: 16px;
          text-align: center;
        }
        &:nth-child(4) .task-btn {
          color: #9d9d9d;
        }
      }
    }
  }
  .xxhy-dialog3-title {
    width: 530px;
    height: 30px;
    margin: 70px 0 40px 50px;
  }
  .xxhy-dialog4-main {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    .reward-bg {
      width: 525px;
      height: 763px;
      margin: -210px 0 10px 0;
    }
    .reward-img {
      width: 77px;
      height: 77px;
      margin-top: -545px;
    }
    .reward-value {
      font-size: 20px;
      background-image: -webkit-linear-gradient(
        180deg,
        #ffc163 0%,
        #ff7f37 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;

      margin-top: 115px;
      .reward-prize {
        font-size: 42px;
        font-weight: 900;
      }
    }
    .reward-name {
      font-size: 20px;
      background-image: -webkit-linear-gradient(
        180deg,
        #ffc163 0%,
        #ff7f37 100%
      );
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
    .reward-btn {
      width: 210px;
      height: 56px;
      cursor: pointer;
      position: absolute;
      top: 320px;
    }
    .reward-tip {
      position: absolute;
      top: 430px;
      text-align: center;
      color: rgba(255, 255, 255, 0.71);
      font-size: 20px;
    }
  }
  .xxhy-page-footer {
    margin-top: -240px;
    img {
      width: 100vw;
    }
    &--text {
      width: 100%;
      text-align: center;
      position: relative;
      bottom: 130px;
      font-size: 16px;
      color: rgba(255, 255, 255, 0.74);
    }
  }
}
</style>
